import localFont from "next/font/local";

export const poppins_400 = localFont({
  src: "./fonts/Poppins/Poppins-Regular.woff2",
  weight: "400",
  style: "normal",
});
export const poppins_500 = localFont({
  src: "./fonts/Poppins/Poppins-Medium.woff2",
  weight: "500",
  style: "normal",
});
export const poppins_600 = localFont({
  src: "./fonts/Poppins/Poppins-SemiBold.woff2",
  weight: "600",
  style: "normal",
});
export const poppins_700 = localFont({
  src: "./fonts/Poppins/Poppins-Bold.woff2",
  weight: "700",
  style: "normal",
});

const poppinsFonts = localFont({
  src: [
    {
      path: "./fonts/Poppins/Poppins-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-Italic.woff2",
      weight: "400",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-Medium.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-MediumItalic.woff2",
      weight: "500",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-SemiBold.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-SemiBoldItalic.woff2",
      weight: "600",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-Bold.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-BoldItalic.woff2",
      weight: "700",
      style: "italic",
    },
  ]
});

const PretendardFonts = localFont({
  src: [
    {
      path: "./fonts/Pretendard/Pretendard-Thin.woff2",
      weight: "100",
    },
    {
      path: "./fonts/Pretendard/Pretendard-ExtraLight.woff2",
      weight: "200",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Light.woff2",
      weight: "300",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Regular.woff2",
      weight: "400",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Medium.woff2",
      weight: "500",
    },
    {
      path: "./fonts/Pretendard/Pretendard-SemiBold.woff2",
      weight: "600",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Bold.woff2",
      weight: "700",
    },
    {
      path: "./fonts/Pretendard/Pretendard-ExtraBold.woff2",
      weight: "800",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Black.woff2",
      weight: "900",
    },
  ],
  display: "swap",
});

const InterFonts = localFont({
  src: [
    {
      path: './fonts/Inter/Inter_18pt-Light.ttf',
      weight: '300',
      style: 'normal',
    },
    {
      path: './fonts/Inter/Inter_18pt-Regular.ttf',
      weight: '400',
      style: 'normal',
    },
    {
      path: './fonts/Inter/Inter_18pt-SemiBold.ttf',
      weight: '600',
      style: 'normal',
    },
    {
      path: './fonts/Inter/Inter_18pt-Bold.ttf',
      weight: '700',
      style: 'normal',
    },
    {
      path: './fonts/Inter/Inter_18pt-ExtraBold.ttf',
      weight: '800',
      style: 'normal',
    },
    {
      path: './fonts/Inter/Inter_18pt-Black.ttf',
      weight: '900',
      style: 'normal',
    }
  ],
  display: 'swap',
})

export const poppins = {
  ...poppinsFonts,
  string: "\"Poppins\", -apple-system, BlinkMacSystemFont, system-ui, \
    Roboto, \"Helvetica Neue\", \"Segoe UI\", \"Apple SD Gothic Neo\", \
    \"Noto Sans KR\", \"Malgun Gothic\", \"Apple Color Emoji\", \
    \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif",
}

export const Pretendard = {
  ...PretendardFonts,
  string: "\"Pretendard\", -apple-system, BlinkMacSystemFont, system-ui, \
    Roboto, \"Helvetica Neue\", \"Segoe UI\", \"Apple SD Gothic Neo\", \
    \"Noto Sans KR\", \"Malgun Gothic\", \"Apple Color Emoji\", \
    \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif",
}

export const Inter = {
  ...InterFonts,
  string: "\"Inter\", -apple-system, BlinkMacSystemFont, system-ui, \
    Roboto, \"Helvetica Neue\", \"Segoe UI\", \"Apple SD Gothic Neo\", \
    \"Noto Sans KR\", \"Malgun Gothic\", \"Apple Color Emoji\", \
    \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif",
}